import { Directive, ElementRef, AfterViewChecked, Input, AfterContentInit } from '@angular/core';

@Directive({
  selector: '[appAutofocus]',
  exportAs: 'autofocus'
})
export class AutofocusDirective implements AfterContentInit {
  @Input('appAutofocusDisabled') disabled?: boolean;


  constructor(private el: ElementRef) {
  }

  ngAfterContentInit() {
    setTimeout(() => {
      if (this.disabled === true) {
        return;
      }
      this.focusElement();
    });
  }

  focusElement() {
    try {
      this.el?.nativeElement.focus();
    } catch { }
  }

}
